<mat-card>
	<mat-card-header>
		<mat-card-title>
			{{title}}
			<mat-icon *ngIf="isLoading">
				<mat-spinner diameter="20"> </mat-spinner>
			</mat-icon>
			<button class="close-button" mat-mini-fab (click)="closeDialog(false)">
				<mat-icon>close</mat-icon>
			</button>
		</mat-card-title>
	</mat-card-header>

	<mat-card-content *ngIf="!isLoading">
		<form [formGroup]="form" (ngSubmit)="submit()" #enrollmentForm="ngForm">
			<div class="row">

				<div class="col-lg-6 border-right">

					<region-dropdown-two-way *ngIf="!isLoading && mode !== 'view'" [isMultiple]="false"
						[(selectedRegions)]="chosenRegions" [(selectedRegion)]="chosenRegion" [reset]="resetField"
						[required]="true" [disabled]="true" [selectUserRegion]="!schoolEnrollment"
						(selectedRegionChange)="regionChanged($event)">
					</region-dropdown-two-way>

					<county-dropdown-two-way *ngIf="!isLoading && mode !== 'view'" [isMultiple]="false"
						[(selectedCounties)]="chosenCounties" [(selectedCounty)]="chosenCounty" [reset]="resetField"
						[required]="true" [regions]="chosenRegions" [disabled]="!!schoolEnrollment"
						(selectedCountyChange)="countyChanged($event)">
					</county-dropdown-two-way>

					<district-dropdown-two-way *ngIf="!isLoading && mode !== 'view'" [isMultiple]="false"
						[(selectedSchoolDistricts)]="chosenSchoolDistricts"
						[(selectedSchoolDistrict)]="chosenSchoolDistrict" [reset]="resetField" [required]="true"
						[regions]="chosenRegions" [counties]="chosenCounties" [disabled]="!!schoolEnrollment"
						(selectedSchoolDistrictChange)="schoolDistrictChanged($event)">
					</district-dropdown-two-way>

					<school-dropdown-two-way *ngIf="!isLoading && mode !== 'view'" [isMultiple]="false"
						[(selectedSchool)]="chosenSchool" [reset]="resetField" [required]="true"
						[regions]="chosenRegions" [counties]="chosenCounties" [schoolDistricts]="chosenSchoolDistricts"
						[disabled]="!!schoolEnrollment" [filterSchoolDistricts]="true" [openSchoolsOnly]="true">
					</school-dropdown-two-way>

					<div class="row">
						<mat-form-field appearance="fill" class="col-lg-12" *ngIf="!isLoading && mode === 'view'">
							<mat-label>
								Region
							</mat-label>
							<input matInput placeholder="Region" [(ngModel)]="schoolEnrollment.REGION.NAME"
								[ngModelOptions]="{standalone: true}" disabled />
						</mat-form-field>
						<mat-form-field appearance="fill" class="col-lg-12" *ngIf="!isLoading && mode === 'view'">
							<mat-label>
								County
							</mat-label>
							<input matInput placeholder="County" [(ngModel)]="schoolEnrollment.COUNTy.COUNTY_NAME"
								[ngModelOptions]="{standalone: true}" disabled />
						</mat-form-field>
						<mat-form-field appearance="fill" class="col-lg-12" *ngIf="!isLoading && mode === 'view'">
							<mat-label>
								School District
							</mat-label>
							<input matInput placeholder="School District"
								[(ngModel)]="schoolEnrollment.SCHOOL_DISTRICT.DISTRICTS"
								[ngModelOptions]="{standalone: true}" disabled />
						</mat-form-field>
						<mat-form-field appearance="fill" class="col-lg-12" *ngIf="!isLoading && mode === 'view'">
							<mat-label>
								School
							</mat-label>
							<input matInput placeholder="School" [(ngModel)]="schoolEnrollment.SCHOOL.NAME"
								[ngModelOptions]="{standalone: true}" disabled />
						</mat-form-field>
					</div>
				</div>

				<div class="col-lg-6">
					<div class="row">
						<div class="col contents">
							<mat-checkbox [color]="'primary'" class="checkbox-margin"
								formControlName="homeSchoolIndicator" (change)="homeSchoolIndicatorEvent($event)">
								Child is being home-schooled
							</mat-checkbox>
							<div class="mat-hint-position">
								<mat-hint>For Non-attending Enrollment Type only</mat-hint>
							</div>
							<help-text-btn class="align-help-text-btn"
								[helpTextId]="'Child_Enrollments_HomeSchooled'"></help-text-btn>
						</div>
					</div>
					<div class="row">
						<div class="col contents">
							<mat-checkbox [color]="'primary'" class="checkbox-margin"
								formControlName="districtOfResidenceIndicator">
								Child lives in a different school district
							</mat-checkbox>
							<help-text-btn class="align-help-text-btn"
								[helpTextId]="'Child_Enrollments_LivesInDifferentDistrict'"></help-text-btn>
						</div>
					</div>
					<div class="row" *ngIf="form.get('districtOfResidenceIndicator')?.value">
						<div class="school-district-margin-adjust" class="col-lg-12">
							<input-organization-autocomplete [id]="'residenceDistrict'" [name]="'School District'"
								[label]="'Search for a School District'" [placeholder]="'Search for a School District'"
								[(selectedOrganization)]="residenceDistrict" [searchCategory]="'School Districts'"
								[(region)]="chosenRegion" [required]="true" [disabled]="mode === 'view'">
							</input-organization-autocomplete>
						</div>
					</div>
					<div class="row">
						<div class="col contents">
							<mat-checkbox [color]="'primary'" class="checkbox-margin"
								formControlName="outOfStateTranscriptIndicator">
								Received transcript(s) from another State
							</mat-checkbox>
							<div class="mat-hint-position">
								<mat-hint>May apply to grades 9-12</mat-hint>
							</div>
							<help-text-btn class="align-help-text-btn"
								[helpTextId]="'Child_Enrollments_TranscriptFromOutOfState'"></help-text-btn>
						</div>
					</div>
				</div>

				<div class="row">
					<div class="col">
						<hr />
					</div>
				</div>

				<div class="row">
					<div class="col-lg-8 border-right">
						<div class="row">


							<div class="col-lg-6 inline">
								<mat-form-field class="w-100">
									<mat-label>
										Enrollment Type
									</mat-label>
									<mat-select formControlName="enrollmentType"
										(selectionChange)="enrollmentTypeChange($event)">
										<mat-option *ngFor="let enrollmentType of enrollmentTypes"
											[value]="enrollmentType.value"
											[disabled]="enrollmentType.disabled || mode === 'view'">
											{{enrollmentType.display}}
										</mat-option>
									</mat-select>
								</mat-form-field>
								<help-text-btn class="align-help-text-btn"
									[helpTextId]="'Child_Enrollments_EnrollmentType'"></help-text-btn>
							</div>

							<div class="col-lg-6">
								<div class="row">
									<app-school-year class="col-lg-12" [label]="'School Year'" [yearType]="'SchoolYear'"
										(performancePeriodEvent)="schoolYearEvent($event)" [currentYearModifier]="0"
										[yearsBack]="1" [yearsForward]="1" [reset]="resetField"
										[selectSchoolYear]="selectSchoolYear"
										[disabled]="!!schoolEnrollment || mode === 'view'" [required]="true">
									</app-school-year>
								</div>
							</div>

						</div>

						<div class="row">

							<div class="col-lg-6 inline">
								<grade-dropdown class="w-100" [(chosenGrades)]="chosenGrades" [required]="true"
									(gradeEvent)="gradeEventEmitter($event)" [isMultiple]="false" [reset]="resetField"
									[disabled]="mode === 'view'">
								</grade-dropdown>
								<help-text-btn class="align-help-text-btn"
									[helpTextId]="'Child_Enrollments_Grade'"></help-text-btn>
							</div>


							<div class="col-lg-6">
								<div class="row">
									<mat-form-field class="col-lg-12">
										<mat-label>
											Track
										</mat-label>
										<input matInput id="track" name="track" type="string" formControlName="track" />
									</mat-form-field>
								</div>
							</div>
						</div>

						<div class="row">
							<div class="col inline">
								<input-organization-autocomplete class="w-100" [id]="'intendToGraduateFrom'"
									[name]="'School'" [label]="'Intend To Graduate From'"
									[hint]="'Type R and 9-12 Students only'"
									[(selectedOrganization)]="selectedIntendToGraduateFrom" [searchCategory]="'Schools'"
									[(region)]="chosenRegion"
									[disabled]="intendToGraduateFromDisabled || mode === 'view'"
									[additionalErrorMsg]="'Optional'">
								</input-organization-autocomplete>
								<help-text-btn class="align-help-text-btn"
									[helpTextId]="'Child_Enrollments_IntendToGraduateFrom'"></help-text-btn>
							</div>
						</div>
					</div>
					<div class="col-lg-4">
						<div class="row">

							<div class="col-12 inline">
								<mat-form-field class="w-100">
									<mat-label>
										Enrollment Date
									</mat-label>
									<input matInput formControlName="enrollmentDate"
										[matDatepicker]="enrollmentDatePicker" (click)="enrollmentDatePicker.open()"
										startView="multi-year" [min]="enrollmentDateOptions.minDate"
										[max]="enrollmentDateOptions.maxDate">
									<mat-datepicker-toggle matSuffix
										[for]="enrollmentDatePicker"></mat-datepicker-toggle>
									<mat-datepicker #enrollmentDatePicker startView="multi-year"
										[startAt]="enrollmentDateOptions.startAt"></mat-datepicker>
								</mat-form-field>
								<help-text-btn class="align-help-text-btn"
									[helpTextId]="'Child_Enrollments_EnrollmentDate'"></help-text-btn>
							</div>


							<div class="col-12 inline">
								<mat-form-field class="w-100">
									<mat-label>
										Withdrawal Date
									</mat-label>
									<input matInput formControlName="withdrawalDate"
										[matDatepicker]="withdrawalDatePicker" (click)="withdrawalDatePicker.open()"
										startView="multi-year" [min]="withdrawalDateOptions.minDate"
										[max]="withdrawalDateOptions.maxDate">
									<mat-datepicker-toggle matSuffix
										[for]="withdrawalDatePicker"></mat-datepicker-toggle>
									<mat-datepicker #withdrawalDatePicker startView="multi-year"
										[startAt]="withdrawalDatePicker.startAt"></mat-datepicker>
								</mat-form-field>
								<help-text-btn class="align-help-text-btn"
									[helpTextId]="'Child_Enrollments_WithdrawalDate'"></help-text-btn>
							</div>


							<div class="col-12 inline">
								<mat-form-field class="w-100">
									<mat-label>
										Departure Date
									</mat-label>
									<input matInput formControlName="departureDate"
										[matDatepicker]="departureDatePicker" (click)="departureDatePicker.open()"
										startView="multi-year" [min]="departureDateOptions.minDate"
										[max]="departureDateOptions.maxDate">
									<mat-datepicker-toggle matSuffix
										[for]="departureDatePicker"></mat-datepicker-toggle>
									<mat-datepicker #departureDatePicker startView="multi-year"
										[startAt]="departureDateOptions.startAt"></mat-datepicker>
								</mat-form-field>
								<help-text-btn class="align-help-text-btn"
									[helpTextId]="'Child_Enrollments_DepartureDate'"></help-text-btn>
							</div>
						</div>
					</div>
				</div>

				<div class="row">
					<div class="col inline">
						<mat-form-field class="w-100">
							<mat-label>
								Enrollment Comment
							</mat-label>
							<textarea matInput id="enrollmentComment" name="enrollmentComment" type="string"
								formControlName="enrollmentComment"></textarea>
							<mat-hint>For example: The student has course completion documents from his home country.
								[Do
								not
								enter PII or health information]</mat-hint>
						</mat-form-field>
						<help-text-btn class="align-help-text-btn"
							[helpTextId]="'Child_Enrollments_Comment'"></help-text-btn>
					</div>
				</div>


				<div class="row" *ngIf="!!schoolEnrollment && mode !== 'view'">
					<div>
						<div class="warn-font-color italic">
							Regular Term Enrollments: Please note that you are unable to remove a date if it already
							exists,
							however you are able to add a new date or change an existing date.
						</div>
					</div>
				</div>

				<div class="row" *ngIf="dateFlags.length > 0">
					<div>
						<div class="warn-font-color italic" *ngFor="let dateFlag of dateFlags">
							{{dateFlag.MIN_MAX}} {{dateFlag.DATE_TYPE}} date is set to {{dateFlag.DATE | simpleDate}}
							due to
							{{dateFlag.NAME | titlecase}}'s
							<span *ngIf="dateFlag.MSD_NUMBER.length > 0">({{dateFlag.MSD_NUMBER}}) </span>
							<span *ngIf="dateFlag.MIN_MAX == 'Minimum' && !dateFlag.ENDING_TYPE">earliest</span>
							<span *ngIf="dateFlag.MIN_MAX == 'Maximum' && !dateFlag.ENDING_TYPE">latest</span>
							<span *ngIf="dateFlag.ENDING_TYPE">{{dateFlag.ENDING_TYPE}}</span>
							{{dateFlag.TYPE}} date.
						</div>
					</div>
				</div>

				<div class="row" *ngIf="dateFlags.length > 0">
					<div>
						<div class="danger bold" *ngFor="let creationFlag of creationFlags">
							{{creationFlag.NAME | titlecase}}'s
							<span *ngIf="creationFlag.MSD_NUMBER.length > 0">({{creationFlag.MSD_NUMBER}})</span>
							{{creationFlag.TYPE}} date {{creationFlag.DATE | simpleDate}}
							is ineligiblity for School Year {{selectedSchoolYear}}.
						</div>
					</div>
				</div>

			</div>
		</form>

		<hr *ngIf="mode !== 'view'" />
	</mat-card-content>

	<mat-card-actions *ngIf="mode !== 'view'">
		<confirm-popover *ngIf="!schoolEnrollment" class="margin-bottom-xs" [buttonType]="'string'" [color]="'primary'"
			[popoverMsg]="'Confirm New School Enrollment'" [popoverConfirmText]="'Create'" [buttonTxt]="'Create'"
			[popoverConfirmColor]="'primary'" (onConfirm)="submit()" [disabled]="isSubmitting || (msg && msg.SUCCESS!)">
		</confirm-popover>
		<confirm-popover *ngIf="schoolEnrollment" class="margin-bottom-xs" [buttonType]="'string'" [color]="'primary'"
			[popoverMsg]="'Confirm Update to School Enrollment'" [popoverConfirmText]="'Update'" [buttonTxt]="'Update'"
			[popoverConfirmColor]="'primary'" (onConfirm)="submit()" [disabled]="isSubmitting || (msg && msg.SUCCESS!)">
		</confirm-popover>

		<button type="button" mat-icon-button *ngIf="isSubmitting">
			<mat-icon>
				<mat-spinner diameter="20"> </mat-spinner>
			</mat-icon>
		</button>
		<app-msg class="margin-left-sm" [msg]="msg" *ngIf="msg?.MSG"></app-msg>
	</mat-card-actions>
</mat-card>